
"use strict";

function J3WTheme() {

    var self = this;

    self.$window = $(window);
    self.$document = $(document);
    self.$body = $("body");
    self.$header = $("#js-header");
    self.$hamburger = $(".hamburger");
    self.$mainMenu = $("#js-main-menu");
    self.$mainNav = $("#main-nav");
    self.$mobileMenu = $("#js-mobile-menu");

    self.init();
}

J3WTheme.prototype = {

    init: function () {

        var self = this;

        self.onBind();
        self.cloneMainMenu();

    },

    onBind: function () {

        var self = this;

        self.$window.on("scroll", function () {
            self.bodyScrollClass(self);
        });

        self.$hamburger.on("click", function () {
            console.log('click');
            self.mobileMenu();
        });

    },

    mobileMenu: function () {

        var self = this, t;

        //self.$body.toggleClass("mobile-menu-is-open");

        var $hamburger = $(".hamburger");

        if (self.$mobileMenu.hasClass("mobile-menu--open")) {
            self.$mobileMenu.removeClass("mobile-menu--open");
            t = setTimeout(function () {
                $hamburger.removeClass("is-active");
            }, 200);
        } else {
            self.$mobileMenu.addClass("mobile-menu--open");
            t = setTimeout(function () {
                $hamburger.addClass("is-active");
            }, 200);
        }

    },

    cloneMainMenu: function () {

        $("#js-main-menu:not(.cloned)").addClass("cloned")
            .clone(true, true)
            .removeAttr("id")
            .appendTo("#js-sticky-menu-container");

    },

    bodyScrollClass: function ( self ) {

        // potrebujeme vedet, jestli se scrolluje dolu nebo nahoru
        if ( ( document.body.getBoundingClientRect() ).top > self.scrollPos ) {
            self.$body.addClass("scroll-up");
        } else {
            self.$body.removeClass("scroll-up");
        }

        self.scrollPos = ( document.body.getBoundingClientRect() ).top;

        if( self.$document.scrollTop() < self.$header.outerHeight() + 100 ) {
            self.$body.addClass("hide-menu");
        } else {
            self.$body.removeClass("hide-menu");
        }

    },
};

$(document).ready(function () {
    new J3WTheme();
});
